export default __webpack_public_path__ + "static/media/icon_cloudDocument@2x.0e58b430.png";